import { Component, OnInit } from '@angular/core';
import { VaultStateService } from '../../services/vault-state.service';

type VaultView = 'receive' | 'pay' | 'ledger';

@Component({
  selector: 'app-vault-console',
  templateUrl: './vault-console.component.html',
  styleUrl: './vault-console.component.scss'
})
export class VaultConsoleComponent implements OnInit {
  visible = false;
  activeView: VaultView = 'receive';
  menuOpen = false; // For mobile menu toggle

  constructor(private vaultState: VaultStateService) { }

  ngOnInit(): void {
    this.vaultState.open$.subscribe(v => {
      this.visible = v;
      if (v) this.activeView = 'receive';
      this.menuOpen = false;
    });
  }

  select(view: VaultView) {
    this.activeView = view;
    this.menuOpen = false; // Close menu on mobile after selection
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  close() {
    this.vaultState.close();
  }
}
